const OnlineMixin = {
  methods: {
    onOnlineChange() {
      // If falsy but not false then online should be true
      this.isOnline = navigator.onLine !== false;
    }
  },
  data() {
    return {
      isOnline: navigator.onLine !== false
    };
  },
  created() {
    window.addEventListener("online", this.onOnlineChange);
    window.addEventListener("offline", this.onOnlineChange);
  },
  destroyed() {
    window.removeEventListener("online", this.onOnlineChange);
    window.removeEventListener("offline", this.onOnlineChange);
  }
};

export default OnlineMixin;
